import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Properties from './pages/Properties';
import PropertyDetails from './pages/PropertyDetails';
import AdminPage from './pages/AdminPage';
import AdminAuth from './pages/AdminAuth';
import About from './pages/About'; // Import the About component
import Contact from './pages/Contact'; // Import the Contact component
import { DarkModeProvider } from './Functions/DarkMode';
import { useEffect } from 'react';
import { trackSiteVisit } from './Functions/TrackingFunctions';
import './assets/css/AdminStyles.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { HelmetProvider } from 'react-helmet-async';
import CancellationPolicy from './pages/CancellationPolicy';

function App() {
  useEffect(() => {
    // Check if this session has already been counted
    const sessionCounted = sessionStorage.getItem('session_visit_counted') === 'true';
    
    if (!sessionCounted) {
      // Track site visit when the app loads (only once per session)
      trackSiteVisit();
      sessionStorage.setItem('session_visit_counted', 'true');
    }
  }, []);

  return (
    <HelmetProvider>
      <DarkModeProvider>
        <div className="App">
          <Router>
            <ToastContainer position="top-right" />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/properties" element={<Properties />} />
              <Route path="/property/:id" element={<PropertyDetails />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/admin-login" element={<AdminAuth />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Home />} />
              <Route path="/terms" element={<Home />} />
              <Route path="/policy" element={<CancellationPolicy />} />
            </Routes>
          </Router>
        </div>
      </DarkModeProvider>
    </HelmetProvider>
  );
}

export default App;
